/**
 * envscan.js — per-scene environmental telemetry for the left-panel ENV-SCAN.
 *
 * These readouts are chip instrumentation: quantities Craine cannot sense
 * unaided (EM flux, RF traffic, ionizing background, pressure rate, particulate
 * chemistry). Values are canon-grounded in scene-bible.json `environment`
 * blocks (app/src/content/knowledge/data/scene-bible.json); keep the two in
 * lockstep when either changes, the bible is authoritative.
 *
 * Fourth-wall rule (demo doctrine): an anomaly line may surface what the
 * instruments register in the room, never the chip's own safety layer or any
 * undiscovered mechanic.
 */

const ENV_SCANS = {
  ds_craine_car: {
    rows: [
      ['air', 'nominal'],
      ['temp', '64.9°F cabin'],
      ['RH', '78%'],
      ['EM', '0.4µT'],
      ['rad', '0.09µSv/h'],
      ['RF', 'LUMEN uplink −51dBm'],
      ['dB', '46 rain'],
      ['lux', '12'],
      ['persons', '1 [host]'],
    ],
    anomaly: null,
  },
  ds_helios_lobby: {
    rows: [
      ['air', 'filtered'],
      ['temp', '68.4°F'],
      ['RH', '41%'],
      ['EM', '2.1µT ▲'],
      ['rad', '0.09µSv/h'],
      ['RF', 'dense / encrypted'],
      ['dB', '38'],
      ['lux', '85'],
      ['persons', '3'],
    ],
    anomaly: 'EM elevated at scan gates; unrequested remote handler resident on the host link',
  },
  ds_helios_office: {
    rows: [
      ['air', 'particulate ▲'],
      ['temp', '67.1°F'],
      ['Δ glass', '−4.2°F'],
      ['RH', '38%'],
      ['EM', '0.7µT'],
      ['rad', '0.11µSv/h'],
      ['RF', 'isolated node'],
      ['dB', '29'],
      ['lux', '64'],
      ['persons', '2'],
    ],
    anomaly: 'paraffin combustion (open flame); desk node off Helios backbone',
  },
  ds_elevator_down: {
    rows: [
      ['air', 'recycled'],
      ['temp', '70.2°F'],
      ['ΔP', '−0.4kPa/s'],
      ['EM', '6.8µT ▲'],
      ['rad', '0.09µSv/h'],
      ['RF', 'shielded car'],
      ['dB', '31 hum'],
      ['lux', '110'],
      ['persons', '1 [host]'],
    ],
    anomaly: 'EM from traction motor; normal for car in motion',
  },
  ds_elevator_up: {
    rows: [
      ['air', 'recycled'],
      ['temp', '70.2°F'],
      ['ΔP', '+0.4kPa/s'],
      ['EM', '6.8µT ▲'],
      ['rad', '0.09µSv/h'],
      ['RF', 'shielded car'],
      ['dB', '31 hum'],
      ['lux', '110'],
      ['persons', '1 [host]'],
    ],
    anomaly: 'EM from traction motor; normal for car in motion',
  },
};

const ENV_DEFAULT = {
  rows: [
    ['air', 'nominal'],
    ['temp', '68.0°F'],
    ['EM', '0.3µT'],
    ['rad', '0.09µSv/h'],
    ['dB', '-12'],
    ['lux', '140'],
    ['persons', '1 [host]'],
  ],
  anomaly: null,
};

export function getEnvScan(sceneId) {
  return ENV_SCANS[sceneId] || ENV_DEFAULT;
}
